import React from "react";
import { multipleClassNames } from "shared/utilities";

import styles from "./Heading.module.scss";

export const Heading = ({ children, className = [] }) => {
  return <h2 className={multipleClassNames([styles.heading, ...className])}>{children}</h2>;
};
